/* eslint-disable eqeqeq */
import { useState, useEffect, useRef, useMemo, Dispatch, SetStateAction, useContext } from 'react';
import {
    copyIcon,
    helperDoc,
    languageIcon,
    speakerIcon,
} from 'assets/icons';
import SourceInfo from 'components/SourceInfo';
import ReactMarkdown from 'react-markdown';
import styles from 'assets/styles/ai-chat-bot/markdownRenderer.module.css'; // Import your CSS module for React markdown
import Actions from './Actions';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { documateComparison, getLanguage, startConversation_v2 } from 'services/coversationService';
import { toast } from 'react-toastify';
import Modal from 'pages/modal';
import * as myconst from "../../constants"
import { useDispatch, useSelector } from 'react-redux';
import { handleDocuMateCalled, handleLoader, setDocuMateValue, handleHideDocCompRadio, handleHideDocSynRadio, handleDocuMateRadio, handleDocuMateUserQuery, handleDocumateLan, handleAnswerCalling, setHistoryCalled } from 'redux/counterSlice';
import UploadConfirmation from 'components/UploadConfirmation';
import { postFileProcessing } from 'services/documentApprovalService';
import Iframe from 'components/Iframe';
import { Dialog } from 'primereact/dialog';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Tag } from 'primereact/tag';
import { confirmPopup, ConfirmPopup } from 'primereact/confirmpopup';
import UploadConfirmationCompare from 'components/UploadConfirmationCompare';
import UploadConfirmationSynthesize from 'components/UploadConfirmationSynthesize';
import StateContext from 'constants/StateContext';
function DocProcessing({
    notify,
    showModal,
    setShowModal,
    iframeRef,
}: any) {
    const { setCurrent, handleDelete, setShowModalCompare, showModalCompare, setShowModalSynthesize, showModalSynthesize, setModalOptionSynthesize, modalOptionSynthesize, setModalOption, modalOption, userQuery, setModalOptionCompare, modalOptionCompare, setShowShare, showShare, setSynthesizeDocName, synthesizeDocName, setComparisonDocName, comparisonDocName, setBase64, base64, setActiveIndex, activeIndex, fileLanguage, setFileLanguage, fileCompLanguage, setFileCompLanguage, fileSynthLanguage, setFileSynthLanguage, setUserQuery, answer, setAnswer, getConversations, inputfilename, setComparisonDocFile, comparisonDocFile, synthesizeDocFile, setSynthesizeDocFile } = useContext<any>(StateContext);
    // const iframeRef:any = useRef<HTMLIFrameElement>(null);
    let featureHistory: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    const TextspeechFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.textSpeech]
    const copyFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.copy]
    const VoiceSearchFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.voiceSearch]
    const SourceInfoFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.sourceInfo]
    const ModelFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.model]
    const inputRef: any = useRef(null);
    const elementRef: any = useRef(null);
    const fileInputRef: any = useRef(null);
    const compSyntfileInputRef: any = useRef(null);
    const params = useParams();
    const approvalRef: any = useRef(null);
    const approvalRefCompare: any = useRef(null);
    const approvalRefSynthesize: any = useRef(null);
    const [query, setQuery] = useState('');
    const [isKeyDown, setIsKeyDown] = useState(false);
    const [isEmailClicked, setIsEmailClicked] = useState([]);
    const location = useLocation()
    const dispatch = useDispatch();
    const promptText = "This chat will be deleted, along with all related activity, including prompts, responses, and feedback from your RysunAI activity."
    const navigate = useNavigate();
    const newChatFind = location.pathname.split('/').filter(entry => entry.trim() != '');
    const inputbox: any = document.querySelector('.input-box');
    const sendButton: any = document.querySelector('#send-button');
    const docuMateCalled = useSelector((state: any) => state.counter.docuMateCalled);
    const docuMatePDF = useSelector((state: any) => state.counter.docuMatePDF);
    const docuMateRadio = useSelector((state: any) => state.counter.docuMateRadio);
    const docuMateRadioClick = useSelector((state: any) => state.counter.docuMateRadioClick);
    const docuMateText = useSelector((state: any) => state.counter.docuMateText);
    const [visible, setVisible] = useState(false)
    const [originalDocName, setOriginalDocName] = useState("");
    const hideDocCompare = useSelector((state: any) => state.counter.hideDocCompare);
    const hideDocSyn = useSelector((state: any) => state.counter.hideDocSyn);

    const handleTabChange = (e: any) => {
        setActiveIndex(e.index);
    };

    const convertPdfToBase64 = async (url: string, setBase64Current: Dispatch<SetStateAction<string>>) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const reader = new FileReader();
            reader.onloadend = () => {
                setBase64Current(reader?.result as any);
            };
            reader.readAsDataURL(blob);
        } catch (error) {
            console.error('Error converting PDF to Base64:', error);
        }
    };

    const handleShowModal = (docType: String) => {
        switch (docType) {
            case 'compare':
                return showModalCompare !== true;
            case 'synthesize':
                return showModalSynthesize !== true;
            case 'original':
                return showModal !== true;
        }
    }

    const [stopId, setStopId] = useState<any>('');
    const userName = localStorage.getItem("username")
    const firstLetter = userName?.charAt(0).toUpperCase();

    const handleSpeak = (screenText: any, id: any) => {
        if ('speechSynthesis' in window) {
            const synth = window.speechSynthesis;
            if (synth.speaking) {
                synth.cancel();
                setStopId('');
            }

            if (stopId != id) {
                const utterance = new SpeechSynthesisUtterance(screenText);

                // Optional settings for the speech
                utterance.lang = 'en-US'; // Language (e.g., US English)
                utterance.volume = 1; // Volume (0 to 1)
                utterance.rate = 1; // Rate of speech (0.1 to 10)
                utterance.pitch = 1; // Pitch (0 to 2)

                // Speak the text
                synth.speak(utterance);
                setStopId(id);

                utterance.onend = () => {
                    setStopId(null);
                };
            }
        }
    };

    //Handle user userQuery of chat conversation
    useEffect(() => {
        setCurrent(params.id);
    })

    const handleShowModalName = (docType: String) => {
        switch (docType) {
            case 'compare':
                return comparisonDocName;
            case 'synthesize':
                return synthesizeDocName;
            case 'original':
                return docuMatePDF.name;
        }
    }
    const uploadDoc = async (docType: string) => {
        const formData = new FormData();
        if (docuMatePDF.pdf !== "" && docuMatePDF.pdf !== undefined) {
            let byteCharacters = ""
            // let byteCharacters = atob(docuMatePDF.pdf);
            if (docType === "compare") {
                // await convertPdfToBase64(base64, setComparisonDocFile)
                byteCharacters = atob(comparisonDocFile.replace("data:application/pdf;base64,", ''));
            } else if (docType === "synthesize") {
                // await convertPdfToBase64(synthesizeDocFile, setSynthesizeDocFile)
                byteCharacters = atob(synthesizeDocFile.replace("data:application/pdf;base64,", ''));
            } else if (docType === "original") {
                // await convertPdfToBase64(synthesizeDocFile, setSynthesizeDocFile)
                byteCharacters = atob(base64.replace("data:application/pdf;base64,", ''));
            } else {
                byteCharacters = atob(docuMatePDF.pdf);
            }
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            // Create Blob
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const pdfFile: any = new File([blob], handleShowModalName(docType), { type: 'application/pdf' });
            formData.append('file', pdfFile);
            const bodyApproval = {
                user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                file: formData
            }

            try {
                if (handleShowModal(docType)) {
                    const { resultApproval, errorApproval } = await postFileProcessing(bodyApproval);
                    if (errorApproval) {
                        throw errorApproval
                    }
                    if (resultApproval?.error) {
                        throw resultApproval.error
                    }
                    if (docType === "compare") {
                        setShowModalCompare(true)
                    } else if (docType === "synthesize") {
                        setShowModalSynthesize(true)
                    } else {
                        setShowModal(true)
                    }
                    toast.success(resultApproval.data.message, {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    })
                }


            } catch (error: any) {
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            }
        }
    }

    const handleSendQueryButton = async () => {
        if (docuMatePDF.pdf !== "" && docuMatePDF.pdf !== undefined) {
            const byteCharacters = atob(docuMatePDF.pdf);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            // Create Blob
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const pdfFile: any = new File([blob], docuMatePDF.name, { type: 'application/pdf' });
            dispatch(handleAnswerCalling(true));
            dispatch(setHistoryCalled(false));
            try {
                const formData = new FormData();
                if (docuMateText.trim() === '' || docuMateRadio !== "Q&A") return;
                setUserQuery([])
                dispatch(handleDocuMateUserQuery([]))
                if (params.id === "new-chat") {
                    const newQuery = {
                        que: docuMateText,
                        isUser: true,
                    };

                    setUserQuery([newQuery]);
                    dispatch(handleDocuMateUserQuery([newQuery]))
                    setAnswer([])
                } else {
                    const newQuery = {
                        que: docuMateText,
                        isUser: true,
                    };

                    setUserQuery([...userQuery, newQuery]);
                    dispatch(handleDocuMateUserQuery([...userQuery, newQuery]))
                }
                formData.append('file', pdfFile)
                dispatch(handleLoader(true));
                const body = {
                    query: docuMateText,
                    user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                    conversation_id: params.id === 'new-chat' ? '' : params.id,
                    on_the_fly: true,
                    file: formData,
                    model: ModelFlag ? ModelFlag : false
                };

                const bodyApproval = {
                    user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                    file: formData
                }

                const { result, error } = await startConversation_v2(body)
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }

                // if (result && !result.error && !error && modalOption === 'yes' && showModal !== true) {
                //     const { resultApproval, errorApproval } = await postFileProcessing(bodyApproval);
                //     setShowModal(true)
                // }

                if (params.id === 'new-chat') {
                    navigate(`/document-processing/${result.conversation_id}`, { replace: true });
                    getConversations();
                }
                await handleCreateCon(result);
                setShowShare(true)
                dispatch(handleLoader(false));
                dispatch(setDocuMateValue(""));
                dispatch(handleDocuMateCalled(false));
                if (elementRef.current) {
                    elementRef?.current?.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            } catch (error: any) {
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                dispatch(handleLoader(false));
            }
        }
    };


    const handleCreateCon = async (response: any) => {
        let newQuery = {
            que: response?.message[0]?.question?.content?.parts[0],
            isUser: true,
            pdfFile: response?.message[0]?.question?.file_data,
            pdfName: response?.message[0]?.question?.file_name
        };
        if (docuMateRadio === 'Compare') {

            let cleanedFileData = response?.message[0]?.question?.file_data.replace(/\/Ron_Project/g, '');
            let fileNamesArray = response?.message[0]?.question?.file_name.split('|');
            let fileDataArray = cleanedFileData.split('|');

            const getCorrectFileName = (fileName: string) => {
                const splitName = fileName.split('___');
                return `${splitName[0]}.pdf`;
            };

            let combinedFiles = fileNamesArray.map((name: string, index: number) => {
                return {
                    fileName: getCorrectFileName(name),
                    filePath: fileDataArray[index]
                };
            });
            setOriginalDocName(combinedFiles[0]?.fileName)
            await convertPdfToBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath.replace('/var/www/html/', ''))}`, setBase64)
            // setBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath)}`);
            setComparisonDocName(combinedFiles[1]?.fileName)
            await convertPdfToBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath.replace('/var/www/html/', ''))}`, setComparisonDocFile)
            // setComparisonDocFile(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`)
            // setSynthesizeDocName(combinedFiles[1]?.fileName)
            // setSynthesizeDocFile(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`)
        } else if (docuMateRadio === 'Synthesization') {

            let cleanedFileData = response?.message[0]?.question?.file_data.replace(/\/Ron_Project/g, '');
            let fileNamesArray = response?.message[0]?.question?.file_name.split('|');
            let fileDataArray = cleanedFileData.split('|');

            const getCorrectFileName = (fileName: string) => {
                const splitName = fileName.split('___');
                return `${splitName[0]}.pdf`;
            };

            let combinedFiles = fileNamesArray.map((name: string, index: number) => {
                return {
                    fileName: getCorrectFileName(name),
                    filePath: fileDataArray[index]
                };
            });
            setOriginalDocName(combinedFiles[0]?.fileName)
            await convertPdfToBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath.replace('/var/www/html/', ''))}`, setBase64)
            // setBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath)}`);
            // setComparisonDocName(combinedFiles[1]?.fileName)
            // setComparisonDocFile(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`)
            setSynthesizeDocName(combinedFiles[1]?.fileName)
            await convertPdfToBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath.replace('/var/www/html/', ''))}`, setSynthesizeDocFile)
            // setSynthesizeDocFile(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`)
        } else {
            setBase64(`${response?.message[0]?.question?.file_data}`);
        }
        setUserQuery([...userQuery, newQuery]);
        dispatch(handleDocuMateUserQuery([...userQuery, newQuery]))
        let obj = {
            ans: {
                response: {
                    output_text:
                        response?.message[0]?.answer?.content?.parts.join("\n"),
                },
                id: response.message[0]?.answer.id,
                created_time: response!.message[0]?.answer?.content?.created_at,
                feedback: response!.message[0]?.answer?.content?.feedback_text,
                source_info: response!.message[0]?.answer?.content?.source_info,
                duration: response?.duration,
            },
        };

        setAnswer([...answer, obj]);
        dispatch(handleAnswerCalling(false));
        setTimeout(() => {
            dispatch(setHistoryCalled(true));
        }, 2000)
        if (params.id == 'new-chat') {
            setCurrent(0);
        }
    };
    const handleEnterPressed = (e: any) => {
        if (e.key === 'Enter') handleSendQueryButton();
    };
    //Handle copy button
    const handleCopy = (text: string) => {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            // setCopySuccess('Text copied to clipboard using fallback method');
        } catch (error) {
            console.error('Error copying text with fallback method:', error);
            // setCopySuccess('Failed to copy text');
        }
        document.body.removeChild(textArea);
    };

    //Handle download button
    const handleDownload = (ques: any, ans: any) => {
        const user = 'H';
        const timestamp = new Date();
        const formattedDate = timestamp.toLocaleDateString('en-US', {});
        const formattedTime = timestamp.toLocaleTimeString('en-US', {});

        const content = `Query: ${ques}\n\nAnswer: ${ans}`;
        const blob = new Blob([content], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `${user} ${formattedDate} ${formattedTime}`;
        document.body.appendChild(a);

        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };



    const handleEmailClick = (index: any) => {
        const updatedEmailClick: any = [...isEmailClicked];
        updatedEmailClick[index] = !updatedEmailClick[index];
        setIsEmailClicked(updatedEmailClick);
    };


    const handleRadioSelect = async () => {
        setShowShare(true)
        const formData = new FormData();
        if (docuMateRadio === "Q&A") {
            return;
        } else {
            if (docuMateRadio !== "") {
                if (docuMatePDF.pdf !== "" && docuMatePDF.pdf !== undefined) {
                    dispatch(handleAnswerCalling(true));
                    dispatch(setHistoryCalled(false));
                    const byteCharacters = atob(docuMatePDF.pdf);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    // Create Blob
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const pdfFile: any = new File([blob], docuMatePDF.name, { type: 'application/pdf' });
                    formData.append('file', pdfFile, docuMatePDF.name);
                    dispatch(handleLoader(true));
                    const body = {
                        query: docuMateRadio,
                        user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                        conversation_id: params.id === 'new-chat' ? '' : params.id,
                        on_the_fly: true,
                        file: formData,
                        model: ModelFlag ? ModelFlag : false
                    };

                    const bodyApproval = {
                        user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                        file: formData
                    }

                    try {
                        const { result, error } = await startConversation_v2(body)
                        if (error) {
                            throw error;
                        }
                        if (result?.error) {
                            throw result.error;
                        }
                        // if (result && !result.error && !error && modalOption === 'yes' && showModal !== true) {
                        //     const { resultApproval, errorApproval } = await postFileProcessing(bodyApproval);
                        //     toast.success("Your request to share the document with us has been forwarded to the administrator for review.")
                        //     setShowModal(true)
                        // }

                        if (params.id === 'new-chat') {
                            navigate(`/document-processing/${result.conversation_id}`, { replace: true });
                            getConversations();
                        }


                        await handleCreateCon(result);
                        dispatch(handleLoader(false));
                        if (elementRef.current) {
                            elementRef?.current?.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                        }
                    } catch (error: any) {
                        toast.error(error, {
                            style: {
                                backgroundColor: '#F1F1F1', // Grey background
                            }
                        });
                        dispatch(handleLoader(false));
                    }
                }
            }
        }
    };

    const modalElement = approvalRef?.current

    const fileToBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = function () {
                resolve(reader.result);
            };

            reader.onerror = function (error) {
                reject(error);
            };
        });
    };

    const manipulateBase64Data = async (base64Data: any): Promise<string> => {
        return new Promise<string>((resolve, reject) => {
            const base64Index = base64Data.indexOf('base64');
            if (base64Index !== -1) {
                resolve(base64Data.slice(base64Index + 7));
            } else {
                resolve(base64Data);
            }
        });
    };

    useEffect(() => {
        if (docuMateRadio !== 'Compare' && docuMateRadio !== 'Synthesization' && docuMateRadio !== docuMateRadioClick) {
            // console.log("Called in documate")
            handleRadioSelect();
        }
    }, [docuMateRadio, docuMateRadioClick])

    useEffect(() => {
        if (docuMateCalled && docuMateRadio !== "") {
            handleSendQueryButton();
        }
    }, [docuMateCalled])

    useEffect(() => {
        if (docuMateRadio === 'Compare' && !hideDocCompare || docuMateRadio === 'Synthesization' && !hideDocSyn) {
            setVisible(true);
            // setOriginalDocFile("")
            // setOriginalDocName("")
            // setComparisonDocFile("")
            // setComparisonDocName("")
        } else {
            setVisible(false);
        }
    }, [docuMateRadio]);

    useEffect(() => {
        const isComparisonPresent = userQuery.some((item: any) => item.que === "Comparison");
        const isSynthesizePresent = userQuery.some((item: any) => item.que === "Synthesization");
        if (isComparisonPresent && !hideDocCompare) {
            dispatch(handleHideDocCompRadio(true));
        }
        if (isSynthesizePresent && !hideDocSyn) {
            dispatch(handleHideDocSynRadio(true));
        }
    }, [userQuery])

    const processedData = useMemo(() => {
        // Perform some expensive computation or data processing here
        // For example, you might filter, map, or sort the data
        return <Iframe ref={iframeRef} modalOption={modalOption} showModal={showModal} showShare={showShare} inputfilename={inputfilename} fileLanguage={fileLanguage} base64PDF={base64} />
    }, [base64, fileLanguage, showModal]);

    const processedCompareData = useMemo(() => {
        return <Iframe ref={iframeRef} modalOption={modalOptionCompare} showModal={showModalCompare} showShare={showShare} inputfilename={comparisonDocName} fileLanguage={fileCompLanguage} base64PDF={comparisonDocFile} />
    }, [comparisonDocFile, showModalCompare]);

    const processedSynthesizeData = useMemo(() => {
        return <Iframe ref={iframeRef} modalOption={modalOptionSynthesize} showModal={showModalSynthesize} showShare={showShare} inputfilename={synthesizeDocName} fileLanguage={fileSynthLanguage} base64PDF={synthesizeDocFile} />
    }, [synthesizeDocFile, showModalSynthesize]);

    const MarkdownRenderer = ({ content }: any) => {
        return (
            <ReactMarkdown
                components={{
                    // Paragraphs
                    p: ({ node, ...props }) => <p className={styles['markdown-paragraph']} {...props} />,

                    // p: ({ children, ...props }) => {
                    //     const lines = children[0]?.toString()?.split('\n') || [];

                    //     let isFirstLine = true;
                    //     const transformedLines = lines.map((line) => {
                    //         const trimmedLine = line.trim();
                    //         const isDotPresent = trimmedLine.includes('•');
                    //         const hasTextBeforeDot = isDotPresent && trimmedLine.indexOf('•') > 0;

                    //         const shouldBreakLine = hasTextBeforeDot && !isFirstLine;

                    //         isFirstLine = false;
                    //         return shouldBreakLine ? '<br>•' + trimmedLine : line;
                    //     });

                    //     let transformedContent = transformedLines.join('<br>');
                    //     transformedContent = transformedContent.replace(/"([^"]*)"/g, '<b>$1</b>');
                    //     transformedContent = transformedContent.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
                    //     return (
                    //         <p
                    //             className={styles['markdown-paragraph']}
                    //             dangerouslySetInnerHTML={{ __html: transformedContent }}
                    //             {...props}
                    //         />
                    //     );
                    // },
                    //  Headings
                    h1: ({ node, ...props }) => (
                        <h1
                            className={styles['markdown-heading1']}
                            {...props}
                        />
                    ),
                    h2: ({ node, ...props }) => (
                        <h2
                            className={styles['markdown-heading2']}
                            {...props}
                        />
                    ),
                    h3: ({ node, ...props }) => (
                        <h3
                            className={styles['markdown-heading3']}
                            {...props}
                        />
                    ),
                    h4: ({ node, ...props }) => (
                        <h4
                            className={styles['markdown-heading4']}
                            {...props}
                        />
                    ),
                    h5: ({ node, ...props }) => (
                        <h5
                            className={styles['markdown-heading5']}
                            {...props}
                        />
                    ),
                    h6: ({ node, ...props }) => (
                        <h6
                            className={styles['markdown-heading6']}
                            {...props}
                        />
                    ),

                    // Lists
                    ul: ({ node, ...props }) => (
                        <ul
                            className={styles['markdown-unordered-list']}
                            {...props}
                        />
                    ),
                    ol: ({ node, ordered, ...props }) => (
                        <ol
                            className={styles['markdown-ordered-list']}
                            {...props}
                        />
                    ),

                    // List Items
                    li: ({ node, ordered, ...props }) => (
                        <li
                            className={styles['markdown-list-item']}
                            {...props}
                        />
                    ),

                    // Links
                    a: ({ node, ...props }: any) => (
                        <a
                            className={styles['markdown-link']}
                            href={node.href}
                            {...props}
                            target="_blank"
                        >
                            {props.children}
                        </a>
                    ),
                    strong: ({ node, ...props }) => (
                        <strong
                            className={styles['markdown-strong']}
                            {...props}
                        />
                    ),
                    // Custom renderer for bold text
                    // bold: ({ node, ...props }:any) => (
                    //     <b className={styles['markdown-bold']}
                    //         {...props}
                    //     />
                    // ),
                    // Code Blocks styling or auto formatting API response...
                    pre: ({ node, ...props }) => (
                        <pre
                            className={styles['markdown-code-block']}
                            {...props}
                        />
                    ),
                    code: ({ inline, node, ...props }) => {
                        if (inline) {
                            return (
                                <code
                                    className={styles['markdown-inline-code']}
                                    {...props}
                                />
                            );
                        }
                        return (
                            //     <SyntaxHighlighter language="javascript" >
                            //     {props.children}
                            // </SyntaxHighlighter>

                            <p>{props.children}</p>
                        );
                    },

                    // Blockquotes
                    blockquote: ({ node, ...props }) => (
                        <blockquote
                            className={styles['markdown-blockquote']}
                            {...props}
                        />
                    ),

                    // Images
                    img: ({ node, ...props }: any) => (
                        <img
                            className={styles['markdown-image']}
                            src={node.src}
                            alt={node.alt}
                            {...props}
                        />
                    ),

                    // Table Headers
                    th: ({ node, ...props }) => (
                        <th
                            className={styles['markdown-table-header']}
                            {...props}
                        />
                    ),

                    // Table Cells
                    td: ({ node, ...props }) => (
                        <td
                            className={styles['markdown-table-cell']}
                            {...props}
                        />
                    ),

                    // Add other components and styles as needed
                }}
            >
                {content}
            </ReactMarkdown>
        );
    };

    // flags
    let featureFlag: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    const is_switch_active = useSelector((state: any) => state.persistent.is_switch_active);
    // Function to convert milisecond to min sec format
    const millisToMinutesAndSeconds = (millis: any) => {
        var minutes = Math.floor(millis / 60000);
        var seconds = Number(((millis % 60000) / 1000).toFixed(0));

        if (minutes === 0) {
            return seconds + " seconds";
        } else {
            return minutes + " minutes " + (seconds < 10 ? '0' : '') + seconds + " seconds";
        }
    }

    const confirm1 = (event: any) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Text Copied',
        });
    };

    const handleFileDrop = async (e: React.DragEvent) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        handleFileUploadCompare(file);
    };

    const handleChange = async (e: any) => {
        const file = e?.target?.files[0];
        if (!file) {
            return;
        }
        handleFileUploadCompare(file);
        e.target.value = null;
    };

    const handleFileUploadCompare = async (fileData: File) => {
        if (!fileData) {
            return;
        }
        if (fileData && fileData?.type === "application/pdf") {
            const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
            if (fileData?.size > maxSize) {
                toast.error('File size should not be more than 10 MB', {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                compSyntfileInputRef.current.value = null
                return;
            }
            dispatch(handleAnswerCalling(true));
            dispatch(setHistoryCalled(false));
            dispatch(handleLoader(true));
            const base64Code: any = await myconst.fileToBase64(fileData)
            const correctBase64 = await myconst.manipulateBase64Data(base64Code)
            const body = {
                query: "",
                user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                file_data: correctBase64,
                file_name: fileData.name
            }
            try {
                const { result, error } = await getLanguage(body)
                if (error) {
                    throw error;
                }
                if (result?.error) {
                    throw result.error;
                }
                if (docuMateRadio === "Compare") {
                    setFileCompLanguage(result.PDF_Language)
                } else if (docuMateRadio === "Synthesization") {
                    setFileSynthLanguage(result.PDF_Language)
                }
                dispatch(handleDocumateLan(result.PDF_Language));
                const formData = new FormData();
                const file = fileData;
                setShowShare(true)
                if (docuMateRadio !== "") {
                    setVisible(false)
                    if (docuMatePDF.pdf !== "" && docuMatePDF.pdf !== undefined) {
                        const byteCharacters = atob(docuMatePDF.pdf);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        // Create Blob
                        const blob = new Blob([byteArray], { type: 'application/pdf' });
                        const pdfFile: any = new File([blob], docuMatePDF.name, { type: 'application/pdf' });
                        formData.append('file', pdfFile, docuMatePDF.name);
                        dispatch(handleLoader(true));
                        const body = {
                            query: docuMateRadio === 'Compare' ? 'Comparison' : 'Synthesization',
                            user_name: localStorage.getItem('username'),
                            file1: pdfFile,
                            file2: file,
                            c_id: params.id !== 'new-chat' ? params.id : null
                        };

                        const bodyApproval = {
                            user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                            file: formData
                        }

                        try {
                            const { result, error } = await documateComparison(body)
                            if (error) {
                                throw error;
                            }
                            if (result?.error) {
                                throw result.error;
                            }
                            if (params.id === 'new-chat') {
                                navigate(`/document-processing/${result.conversation_id}`, { replace: true });
                                getConversations();
                            }
                            await handleCreateCon(result);
                            dispatch(handleLoader(false));
                            if (elementRef.current) {
                                elementRef?.current?.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                            }
                        } catch (error: any) {
                            toast.error(error, {
                                style: {
                                    backgroundColor: '#F1F1F1', // Grey background
                                }
                            });
                            dispatch(handleLoader(false));
                        }
                    }
                }
            } catch (error: any) {
                if (error === "Please upload a text document;scanned documents and image only PDFs won't be processed.") {
                    toast.error("Please upload a text document. Blank documents, scanned documents, and image only PDFs cannot be processed", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                    dispatch(handleLoader(false));
                } else if (error === "EOF marker not found") {
                    toast.error("The file is corrupted or incomplete and cannot be processed. Please upload a valid file", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                    dispatch(handleLoader(false));
                } else if (error === "File has not been decrypted") {
                    toast.error("The uploaded file is encrypted or password-protected. Please decrypt it and try again", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                    dispatch(handleLoader(false));
                } else {
                    toast.error(error, {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                    dispatch(handleLoader(false));
                }
            }
            // compSyntfileInputRef.current.value = null
        } else {
            toast.error("File is not supported", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
            compSyntfileInputRef.current.value = null
        }
    }

    const handleDialogClose = () => {
        setVisible(false);
        if (docuMateRadio === 'Compare' || docuMateRadio === 'Synthesization') {
            dispatch(handleDocuMateRadio(docuMateRadioClick));
            // dispatch(handleDocuMateRadioClick(""));
        }
    };

    return (
        <>
            <section
                className={`chat-component-main-section documate-main-section`}
            >
                {docuMatePDF.pdf !== "" &&
                    <div className='chat-component-main-container'>
                        <div className='chats-conversation-container' ref={elementRef}>
                            {/* dynamic data */}

                            {userQuery
                                ?.map((userMessage: any, index: any) => {

                                    if (
                                        answer?.length > 1 &&
                                        index == 0 &&
                                        answer[0]?.ans.isFirst
                                    )
                                        return;
                                    else
                                        return (
                                            <div
                                                className='chats-conversation'
                                                key={index}
                                                style={{ position: 'relative' }}
                                            >
                                                <div className='user chat-user-head'>
                                                    <div className='chat-user-left'>

                                                        {answer[index]?.ans.isFirst ? (
                                                            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="17" cy="17" r="16.5" fill="#333A96" fillOpacity="0.1" stroke="black" />
                                                                <path d="M20.5585 24.0304H13.5519C13.0858 24.0304 12.6328 23.9739 12.1996 23.8674C11.6887 23.7418 11.2051 23.5466 10.7596 23.2925C10.4153 23.0961 10.0936 22.8646 9.79957 22.6027C8.63852 21.5688 7.90723 20.0627 7.90723 18.3858V15.4076C7.90723 12.2902 10.4345 9.76292 13.5519 9.76292H20.5585C23.6759 9.76292 26.2032 12.2902 26.2032 15.4076V18.3839C26.2032 21.5031 23.6759 24.0304 20.5585 24.0304Z" fill="#0512C4" />
                                                                <path d="M26.6485 21.0711H26.0918V14.2871H26.6485C27.9474 14.2871 28.9995 15.3392 28.9995 16.6381V18.7219C28.9995 20.019 27.9474 21.0711 26.6485 21.0711Z" fill="#303030" />
                                                                <path d="M7.35101 21.0711H7.90768V14.2871H7.35101C6.05211 14.2871 5 15.3392 5 16.6381V18.7219C5 20.019 6.05211 21.0711 7.35101 21.0711Z" fill="#303030" />
                                                                <path d="M20.598 14.2909H13.5134C12.0735 14.2909 10.9082 15.458 10.9082 16.8961C10.9082 18.336 12.0754 19.5013 13.5134 19.5013H20.5962C22.0361 19.5013 23.2014 18.3342 23.2014 16.8961C23.2032 15.458 22.0361 14.2909 20.598 14.2909ZM13.5617 17.9018C13.0069 17.9018 12.5578 17.4528 12.5578 16.898C12.5578 16.3432 13.0069 15.8941 13.5617 15.8941C14.1165 15.8941 14.5655 16.3432 14.5655 16.898C14.5655 17.4509 14.1165 17.9018 13.5617 17.9018ZM20.5498 17.9018C19.9949 17.9018 19.5459 17.4528 19.5459 16.898C19.5459 16.3432 19.9949 15.8941 20.5498 15.8941C21.1046 15.8941 21.5536 16.3432 21.5536 16.898C21.5536 17.4509 21.1046 17.9018 20.5498 17.9018Z" fill="#F2F9FD" />
                                                                <path d="M19.5612 27.1406H18.2363C18.0823 27.1406 17.958 27.0162 17.958 26.8622C17.958 26.7082 18.0823 26.5839 18.2363 26.5839H19.5612C23.072 26.5839 25.9258 23.7282 25.9258 20.2193V13.285C25.9258 9.57384 22.9068 6.55667 19.1975 6.55667H14.9149C11.2037 6.55667 8.18656 9.57569 8.18656 13.285V21.5441C8.18656 21.6982 8.06223 21.8225 7.90822 21.8225C7.75421 21.8225 7.62988 21.6982 7.62988 21.5441V13.285C7.62988 9.26767 10.8975 6 14.9149 6H19.1975C23.2148 6 26.4825 9.26767 26.4825 13.285V20.2193C26.4825 24.0362 23.3781 27.1406 19.5612 27.1406Z" fill="#303030" />
                                                                <path d="M19.3698 28.1608H16.4603C15.9908 28.1608 15.6123 27.7804 15.6123 27.3128V26.5056C15.6123 26.0361 15.9927 25.6576 16.4603 25.6576H19.3698V28.1608Z" fill="#303030" />
                                                            </svg>
                                                        ) : (
                                                            <div className="user-icon" > {firstLetter} </div>
                                                        )}
                                                        <p className='query'>
                                                            {userMessage?.que}
                                                        </p>
                                                    </div>
                                                    <div className='chat-user-right'>
                                                        {(!answer[index]?.ans.isFirst && (TextspeechFlag === true || TextspeechFlag === undefined)) && (
                                                            <span className='conversation-section-icon-top'
                                                                onClick={() =>
                                                                    handleSpeak(
                                                                        userMessage.que,
                                                                        answer[index]?.ans
                                                                            .id
                                                                    )
                                                                }
                                                                style={
                                                                    stopId ==
                                                                        answer[index]?.ans.id
                                                                        ? {
                                                                            backgroundColor:
                                                                                '#F1F1F1',
                                                                            border: '1px solid #404040',
                                                                            borderRadius:
                                                                                '50%',
                                                                        }
                                                                        : {}
                                                                }>
                                                                <img
                                                                    data-tooltip-id='my-tooltip'
                                                                    data-tooltip-content='Text-to-Speech'
                                                                    title='Text to Speech'
                                                                    className='speaker-button'
                                                                    src={speakerIcon}
                                                                    alt='copy-button'
                                                                />
                                                            </span>
                                                        )}
                                                        {(!answer[index]?.ans.isFirst && (copyFlag === true || copyFlag === undefined)) && (
                                                            <span className='conversation-section-icon-top'
                                                                onClick={(e) => {
                                                                    handleCopy(
                                                                        userMessage.que
                                                                    );
                                                                    confirm1(e)
                                                                }
                                                                }
                                                            >
                                                                <img
                                                                    data-tooltip-id='my-tooltip'
                                                                    data-tooltip-content='Copy'
                                                                    title='Copy'
                                                                    className='copy-button'
                                                                    src={copyIcon}
                                                                    alt='copy-button'
                                                                />
                                                            </span>
                                                        )}

                                                        {/* {(index === 0) && (userMessage.pdfFile !== "" || userMessage.pdfFile !== undefined || userMessage.pdfFile !== null) && newChatFind[1] !== 'new-chat' && (<div>
                                                        <PDFConverter base64PDF={userMessage.pdfFile} />
                                                    </div>)} */}
                                                    </div>
                                                </div>
                                                <div className='chat-user-body'>
                                                    <div className='bot'>
                                                        {!answer[index]?.ans
                                                            .isFirst && (
                                                                // <img
                                                                //     src={brandLogo}
                                                                //     alt='bot-icon'
                                                                // />
                                                                <svg width="30" height="32" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7907 2.23254C10.1741 2.23254 9.67438 2.7323 9.67438 3.3488V4.83716C9.67438 5.45366 10.1741 5.95343 10.7907 5.95343H18.2324C18.8489 5.95343 19.3487 5.45365 19.3487 4.83716V4.10758C19.3486 4.10162 19.3486 4.09566 19.3487 4.08968L19.3487 4.08448V3.3488C19.3487 2.73232 18.8489 2.23254 18.2324 2.23254H10.7907ZM21.5625 2.99261C21.3847 1.31056 19.9616 0 18.2324 0H10.7907C9.06148 0 7.63841 1.31057 7.46057 2.9926C6.32482 3.01573 5.3428 3.07448 4.50429 3.2285C3.37612 3.43573 2.41602 3.8305 1.63474 4.61178C0.853481 5.39304 0.458708 6.3531 0.251473 7.48123C0.0500997 8.57745 0.0115711 9.91896 0.00260872 11.5286C-0.000824006 12.1451 0.496156 12.6476 1.11264 12.651C1.72913 12.6545 2.23168 12.1575 2.23511 11.541C2.24417 9.91359 2.28645 8.76006 2.44727 7.88459C2.60223 7.04103 2.85104 6.55276 3.21338 6.19042C3.57572 5.82808 4.06401 5.57926 4.90763 5.4243C5.57147 5.30236 6.39519 5.24858 7.46415 5.22575C7.65671 6.89219 9.07259 8.18597 10.7907 8.18597H18.2324C19.9504 8.18597 21.3664 6.8922 21.5589 5.22575C22.6278 5.24858 23.4515 5.30236 24.1153 5.4243C24.9589 5.57926 25.4472 5.82808 25.8096 6.19043C26.2215 6.60235 26.4901 7.18069 26.6369 8.2728C26.7881 9.39703 26.7904 10.887 26.7904 13.0234V16.0002C26.7904 16.6167 27.2902 17.1164 27.9067 17.1164C28.5232 17.1164 29.023 16.6167 29.023 16.0002V12.9418C29.023 10.9063 29.023 9.26567 28.8495 7.97531C28.6694 6.63563 28.2841 5.50764 27.3882 4.61177C26.6069 3.8305 25.6468 3.43573 24.5186 3.2285C23.6802 3.07448 22.6982 3.01573 21.5625 2.99261ZM5.95337 13.7673C5.95337 13.1508 6.45314 12.651 7.06964 12.651H14.5114C15.1279 12.651 15.6277 13.1508 15.6277 13.7673C15.6277 14.3838 15.1279 14.8836 14.5114 14.8836H7.06964C6.45314 14.8836 5.95337 14.3838 5.95337 13.7673ZM17.8602 13.7673C17.8602 13.1508 18.36 12.651 18.9765 12.651H21.9532C22.5697 12.651 23.0695 13.1508 23.0695 13.7673C23.0695 14.3838 22.5697 14.8836 21.9532 14.8836H18.9765C18.36 14.8836 17.8602 14.3838 17.8602 13.7673ZM1.11627 16.3722C1.73277 16.3722 2.23254 16.872 2.23254 17.4885V21.9536C2.23254 24.09 2.23491 25.58 2.38606 26.7043C2.53289 27.7964 2.80146 28.3747 3.21334 28.7866C3.62527 29.1985 4.20364 29.4671 5.29576 29.6139C6.41999 29.7651 7.91 29.7675 10.0464 29.7675H18.9766C21.113 29.7675 22.603 29.7651 23.7272 29.6139C24.8193 29.4671 25.3976 29.1985 25.8096 28.7866C26.2215 28.3747 26.4901 27.7964 26.6369 26.7043C26.7881 25.58 26.7904 24.09 26.7904 21.9536C26.7904 21.3371 27.2902 20.8373 27.9067 20.8373C28.5232 20.8373 29.023 21.3371 29.023 21.9536V22.0353C29.023 24.0707 29.023 25.7114 28.8495 27.0017C28.6694 28.3414 28.2841 29.4694 27.3882 30.3652C26.4923 31.2611 25.3643 31.6465 24.0247 31.8266C22.7343 32.0001 21.0937 32 19.0582 32H9.96473C7.92927 32 6.28863 32.0001 4.99827 31.8266C3.65859 31.6465 2.5306 31.2611 1.63473 30.3652C0.738854 29.4694 0.35354 28.3414 0.173429 27.0017C-5.46277e-05 25.7114 -2.98472e-05 24.0707 8.12006e-07 22.0353L1.66365e-06 17.4885C1.66365e-06 16.872 0.499772 16.3722 1.11627 16.3722ZM7.44185 18.9766C7.44185 18.3601 7.94162 17.8603 8.55812 17.8603H10.0465C10.663 17.8603 11.1627 18.3601 11.1627 18.9766C11.1627 19.5931 10.663 20.0928 10.0465 20.0928H8.55812C7.94162 20.0928 7.44185 19.5931 7.44185 18.9766ZM13.3953 18.9766C13.3953 18.3601 13.895 17.8603 14.5115 17.8603H20.465C21.0815 17.8603 21.5812 18.3601 21.5812 18.9766C21.5812 19.5931 21.0815 20.0928 20.465 20.0928H14.5115C13.895 20.0928 13.3953 19.5931 13.3953 18.9766ZM8.93015 24.1858C8.93015 23.5693 9.42992 23.0696 10.0464 23.0696H18.9766C19.5931 23.0696 20.0928 23.5693 20.0928 24.1858C20.0928 24.8023 19.5931 25.3021 18.9766 25.3021H10.0464C9.42992 25.3021 8.93015 24.8023 8.93015 24.1858Z" fill="#5627D9" />
                                                                </svg>
                                                            )}
                                                        {!(answer?.length == 1 &&
                                                            index == 0 &&
                                                            answer[0]?.ans.isFirst) && (
                                                                <div className='answer'>
                                                                    {answer[index]?.ans
                                                                        .response
                                                                        .output_text !==
                                                                        undefined ? (
                                                                        <MarkdownRenderer
                                                                            content={
                                                                                answer[
                                                                                    index
                                                                                ]?.ans
                                                                                    .response
                                                                                    .output_text
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        // : <LoadingAnimationSVG /> : <p>something went wrong</p>
                                                                        <div className='loading-animation'>
                                                                            <div className='line line1'></div>
                                                                            <div className='line line2'></div>
                                                                            <div className='line line3'></div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                    </div>
                                                    {/* Learn More Section starts here */}
                                                    {(answer[index]?.ans?.source_info
                                                        ?.length > 0 && (SourceInfoFlag === true || SourceInfoFlag === undefined)) && (
                                                            <SourceInfo
                                                                data={
                                                                    answer[index]?.ans
                                                                        .source_info
                                                                }
                                                            />
                                                        )}

                                                    {(
                                                        !answer[index]?.ans?.isFirst && answer[index]?.ans?.response !== undefined
                                                    ) && (
                                                            <Actions
                                                                stopId={stopId}
                                                                notify={notify}
                                                                answer={answer}
                                                                index={index}
                                                                userMessage={userMessage}
                                                                setAnswer={setAnswer}
                                                                handleCopy={handleCopy}
                                                                handleDownload={
                                                                    handleDownload
                                                                }
                                                                handleSpeak={handleSpeak}
                                                                handleEmailClick={
                                                                    handleEmailClick
                                                                }
                                                                isEmailClicked={
                                                                    isEmailClicked
                                                                }
                                                                confirm1={confirm1}
                                                                feedbacktext={
                                                                    answer[index]?.ans
                                                                        .feedback
                                                                }
                                                            />
                                                        )}
                                                </div>
                                                {(!answer[index]?.ans.isFirst && answer[index]?.ans?.response) && (
                                                    answer[index]?.ans?.response.output_text !== undefined &&
                                                    <>
                                                        {/* <div className="response-details">
                                                        <p className='response-time'
                                                        >
                                                            {moment(
                                                                answer[index]?.ans
                                                                    .created_time
                                                            ).format(
                                                                'MMM DD, YYYY HH:mm:ss'
                                                            )}
                                                        </p>
                                                    </div> */}
                                                        {answer[index]?.ans?.duration && is_switch_active && featureFlag.debug && <>
                                                            <hr className='mb-0' />
                                                            <div className='ps-3 pt-2 fs-14  bg-body-tertiary'>
                                                                <strong>Debug</strong>:- <br />
                                                                <ul>
                                                                    <li>
                                                                        Response time: {millisToMinutesAndSeconds(answer[index]?.ans.duration)}.
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </>}
                                                    </>
                                                )}
                                            </div>
                                        );
                                })
                                .reverse()}
                        </div>
                    </div>}

                <div className='uploded-pdf'>
                    {(base64 !== "" && (docuMateRadio !== 'Compare' && docuMateRadio !== 'Synthesization') && (!comparisonDocFile && !synthesizeDocFile)) &&
                        <>
                            {processedData}
                            {/* <Iframe ref={iframeRef} modalOption={modalOption} showModal={showModal} showShare={showShare} inputfilename={inputfilename} fileLanguage={fileLanguage} base64PDF={base64} /> */}
                        </>
                    }
                    {
                        ((docuMateRadio === 'Compare' || docuMateRadio === 'Synthesization' || comparisonDocFile || synthesizeDocFile) && base64 !== "") &&
                        <div className={`compare-accordion ${(comparisonDocName && synthesizeDocName) && 'accordion-document-container'}`}>
                            <Accordion activeIndex={activeIndex} onTabChange={handleTabChange}>
                                {/* <AccordionTab header="Header I">
                            {processedData}
                        </AccordionTab> */}
                                <AccordionTab header={<div className='pdf-viewer-wrapper'><div className='pdf-viewer-header'>
                                    {
                                        inputfilename ?
                                            (<strong className='text-sm fw-semibold flex align-items-center' >
                                                <strong className='pdf-header' title={inputfilename}>
                                                    {inputfilename?.length > 17
                                                        ? `${inputfilename?.slice(0, 17 / 2)}...${inputfilename?.slice(-17 / 2)}`
                                                        : inputfilename}
                                                </strong>
                                                {(inputfilename && showShare) && <a data-bs-toggle={showModal === false && "modal"} data-bs-target="#upload-doc" onClick={(e) => {
                                                    e.stopPropagation();
                                                    {
                                                        showModal === true && toast.warn("file already uploaded", {
                                                            style: {
                                                                backgroundColor: '#F1F1F1', // Grey background
                                                            }
                                                        })
                                                    }
                                                }}><i className={modalOption !== "yes" ? "pi pi-share-alt " : "pi pi-share-alt text-success"} ></i></a>} </strong>) :
                                            (<strong className='text-sm flex align-items-center fw-semibold' >
                                                <strong className='pdf-header' title={docuMatePDF.name}>
                                                    {docuMatePDF.name?.length > 17
                                                        ? `${docuMatePDF.name.slice(0, 17 / 2)}...${docuMatePDF.name.slice(-17 / 2)}`
                                                        : docuMatePDF.name}
                                                </strong>
                                                {(docuMatePDF.name && showShare) && <a data-bs-toggle={showModal === false && "modal"} data-bs-target="#upload-doc" onClick={(e) => {
                                                    e.stopPropagation();
                                                    {
                                                        showModal === true && toast.warn("File already shared", {
                                                            style: {
                                                                backgroundColor: '#F1F1F1', // Grey background
                                                            }
                                                        })
                                                    }
                                                }}><i className={modalOption !== "yes" ? "pi pi-share-alt" : "pi pi-share-alt text-success"} ></i></a>}</strong>)
                                    }
                                    <div className='pdf-lang fw-semibold'><i><img src={languageIcon} alt='qmate-icon' /></i>{fileLanguage === "af" ? "African-Language" : fileLanguage === "en" ? "English" : fileLanguage}</div>
                                </div></div>}>
                                    {processedData}
                                </AccordionTab>
                                {/* <AccordionTab header="Header II">
                            {processedCompareData}
                        </AccordionTab> */}
                                {comparisonDocFile &&
                                    <AccordionTab header={<div className='pdf-viewer-wrapper'><div className='pdf-viewer-header'>
                                        {comparisonDocName &&
                                            (<strong className='text-sm fw-semibold flex align-items-center' >
                                                {comparisonDocName?.length > 17
                                                    ? <strong className='pdf-header' title={comparisonDocName}>{`${comparisonDocName?.slice(0, 17 / 2)}...${comparisonDocName?.slice(-17 / 2)}`}</strong>
                                                    : comparisonDocName}
                                                {(comparisonDocName && showShare) && <a data-bs-toggle={showModalCompare === false && "modal"} data-bs-target="#upload-doc-compare" onClick={(e) => {
                                                    e.stopPropagation();
                                                    {
                                                        showModalCompare === true && toast.warn("File already shared", {
                                                            style: {
                                                                backgroundColor: '#F1F1F1',
                                                            }
                                                        })
                                                    }
                                                }}><i className={modalOptionCompare !== "yes" ? "pi pi-share-alt " : "pi pi-share-alt text-success"} ></i></a>} </strong>)
                                            //     :
                                            // (<strong className='text-sm flex align-items-center fw-semibold' title={docuMatePDF.name}>
                                            //     {docuMatePDF.name?.length > 17
                                            //         ? `${docuMatePDF.name.slice(0, 17 / 2)}...${docuMatePDF.name.slice(-17 / 2)}`
                                            //         : docuMatePDF.name}
                                            //     {(docuMatePDF.name && showShare) && <a data-bs-toggle={showModal === false && "modal"} data-bs-target="#upload-doc" onClick={(e) => 
                                            //     {e.stopPropagation();
                                            //     {
                                            //         showModal === true && toast.warn("File already shared", {
                                            //             style: {
                                            //                 backgroundColor: '#F1F1F1', // Grey background
                                            //             }
                                            //         })
                                            //     }}}><i className={modalOption !== "yes" ? "pi pi-share-alt" : "pi pi-share-alt text-success"} ></i></a>}</strong>)
                                        }
                                        <div className='pdf-lang fw-semibold'><Tag value={"Compare"}></Tag><i><img src={languageIcon} alt='qmate-icon' /></i>{fileCompLanguage === "af" ? "African-Language" : fileCompLanguage === "en" ? "English" : fileCompLanguage}</div>
                                    </div></div>}>
                                        {processedCompareData}
                                    </AccordionTab>
                                }
                                {/* <AccordionTab header="Header III">
                            {processedSynthesizeData}
                        </AccordionTab> */}
                                {synthesizeDocFile &&
                                    <AccordionTab header={<div className='pdf-viewer-wrapper'><div className='pdf-viewer-header'>
                                        {synthesizeDocName &&
                                            (<strong className='text-sm fw-semibold flex align-items-center' >
                                                <strong className='pdf-header' title={synthesizeDocName}>
                                                    {synthesizeDocName?.length > 17
                                                        ? `${synthesizeDocName?.slice(0, 17 / 2)}...${synthesizeDocName?.slice(-17 / 2)}`
                                                        : synthesizeDocName}
                                                </strong>
                                                {(synthesizeDocName && showShare) && <a data-bs-toggle={showModalSynthesize === false && "modal"} data-bs-target="#upload-doc-synthesize" onClick={(e) => {
                                                    e.stopPropagation();
                                                    {
                                                        showModalSynthesize === true && toast.warn("File already shared", {
                                                            style: {
                                                                backgroundColor: '#F1F1F1',
                                                            }
                                                        })
                                                    }
                                                }}><i className={modalOptionSynthesize !== "yes" ? "pi pi-share-alt " : "pi pi-share-alt text-success"} ></i></a>} </strong>)
                                            //      :
                                            // (<strong className='text-sm flex align-items-center fw-semibold' title={docuMatePDF.name}>
                                            //     {docuMatePDF.name?.length > 17
                                            //         ? `${docuMatePDF.name.slice(0, 17 / 2)}...${docuMatePDF.name.slice(-17 / 2)}`
                                            //         : docuMatePDF.name}
                                            //     {(docuMatePDF.name && showShare) && <a data-bs-toggle={showModal === false && "modal"} data-bs-target="#upload-doc" onClick={(e) => 
                                            //     {e.stopPropagation();
                                            //     {
                                            //         showModal === true && toast.warn("File already shared", {
                                            //             style: {
                                            //                 backgroundColor: '#F1F1F1', // Grey background
                                            //             }
                                            //         })
                                            //     }}}><i className={modalOption !== "yes" ? "pi pi-share-alt" : "pi pi-share-alt text-success"} ></i></a>}</strong>)
                                        }
                                        <div className='pdf-lang fw-semibold'><Tag value={"Synthesization"}></Tag><i><img src={languageIcon} alt='qmate-icon' /></i>{fileSynthLanguage === "af" ? "African-Language" : fileSynthLanguage === "en" ? "English" : fileSynthLanguage}</div>
                                    </div></div>}>
                                        {processedSynthesizeData}
                                    </AccordionTab>
                                }
                            </Accordion>
                        </div>
                    }
                </div>
            </section>
            <ConfirmPopup
                content={({ message, hide }) =>
                    <div className="bg-gray-900 border-round custom-tooltip">
                        <span>{message}</span>
                        <span className='d-none'>
                            {setTimeout(() => {
                                hide()
                            }, 2000) as any}
                        </span>
                    </div>
                }
            />
            <UploadConfirmation
                setModalOption={setModalOption}
                modalOption={modalOption}
                approvalRef={approvalRef}
                uploadDoc={uploadDoc}
            />
            <UploadConfirmationCompare
                setModalOption={setModalOptionCompare}
                modalOption={modalOption}
                approvalRef={approvalRefCompare}
                uploadDoc={uploadDoc}
            />
            <UploadConfirmationSynthesize
                setModalOption={setModalOptionSynthesize}
                modalOption={modalOption}
                approvalRef={approvalRefSynthesize}
                uploadDoc={uploadDoc}
            />
            <Dialog
                visible={visible}
                className="custom-dialog"
                style={{ width: '550px', borderRadius: '10px' }}
                draggable={false}
                header={
                    <div className="custom-dialog-header">
                        {docuMateRadio === "Compare" ? "Upload Document to Compare" : "Upload Document to Synthesization"}
                    </div>
                }
                onHide={() => handleDialogClose()}
            >
                <div className="doc-compare-section">
                    <div className="container-one">
                        <div className="inner-container">
                            <div className="image-section">
                                <div className="input-container"
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={handleFileDrop}
                                    onDragLeave={(e) => e.preventDefault()}
                                >
                                    <label htmlFor="fileUpload">
                                        <img src={helperDoc} alt="Upload" className="upload-icon" />
                                        <p><span>Click to Upload</span> or Drag and Drop Document</p>
                                    </label>
                                    <input
                                        type="file"
                                        id="fileUpload"
                                        accept=".pdf"
                                        ref={compSyntfileInputRef}
                                        onChange={handleChange}
                                    />
                                </div>
                                <p className="mt-2 mb-0 file-info">
                                    <p className='helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i>Only PDF files with a maximum file size limit of <b>10 MB</b>.</p>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
}

export default DocProcessing;